module.exports = __webpack_public_path__ + "static/media/Employer_5.ff77605b.svg";